import { Inbox } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

/**
 * Einheitlicher "keine Daten"-Hinweistext, vorher 4-fach wortgleich in
 * Watchlist/Depot/Krisen-Stresstest/Alerts-Center kopiert. `card` (default true)
 * steuert, ob eine eigene Kachel gerendert wird - manche Aufrufer (z.B.
 * CrisisStressTestPanel) sitzen bereits in einer vom Elternelement gestellten Kachel
 * und würden sonst doppelt umrandet.
 *
 * UI-Politur-Durchgang (Feedback-Runde 11, 2026-07-22): kleines, neutral-gedecktes
 * Icon ergaenzt - vorher nur eine blanke Textzeile ("wie von mehreren
 * UI-/UX-Designern gemacht", eigenes Gespuer fuer eine Stelle mit projektweiter
 * Hebelwirkung: eine Aenderung hier wirkt an allen ~6 Verwendungsstellen). Bewusst
 * NICHT der Gold-Akzent (der bleibt fuer Premium-/Röntgenblick-Momente reserviert,
 * ein leerer Zustand ist kein besonderer Moment) - neutrales Muted-Grau passend zum
 * Text selbst.
 */
export function EmptyState({ message, card = true }: { message: string; card?: boolean }) {
  const text = (
    <div className="flex flex-col items-center gap-2 text-center">
      <span className="flex size-8 items-center justify-center rounded-full bg-muted text-muted-foreground">
        <Inbox className="size-4" aria-hidden="true" />
      </span>
      <p className="max-w-sm text-sm text-muted-foreground">{message}</p>
    </div>
  );
  if (!card) return text;
  return (
    <Card>
      <CardContent className="pt-6">{text}</CardContent>
    </Card>
  );
}
